import Field from "../Field";

export default class QuickStepSetupField extends Field {
    onChange = nextValue => {
        let item = this.items.find(x => x.value === nextValue)
        if (item && item.attributes) {
            this.step.getField('primary.inletTemperature').setValue(item.attributes['primary.InletTemperature'])
            this.step.getField('primary.outletTemperature').setValue(item.attributes['primary.OutletTemperature'])
            this.step.getField('secondary.inletTemperature').setValue(item.attributes['secondary.InletTemperature'])
            this.step.getField('secondary.outletTemperature').setValue(item.attributes['secondary.OutletTemperature'])
        }
    }
}